// extracted by mini-css-extract-plugin
export var growableInput = "_87-0";
export var tagContainer = "_87-2";
export var textInput = "_87-1";